import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  PaginatedResponse,
  OrderSummaryDto,
  OrderDetailDto,
  GetOrdersParams,
  RepackCreateRequestDto,
  RepackUpdateRequestDto,  // New DTO
  RepackCancelRequestDto,
  StatusUpdateRequestDto,
  EligibleCartonsRequest,
  EligibleCartonDto,
} from '../../models/order.dto'; // Adjust path if needed

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  private apiUrl = `${environment.apiUrl}/orders`; // Base URL for order endpoints

  constructor(private http: HttpClient) { }

  // Get a paginated list of orders with optional filters
  getOrders(params?: GetOrdersParams): Observable<PaginatedResponse<OrderSummaryDto>> {
    let httpParams = new HttpParams();

    if (params) {
      if (params.status) {
        httpParams = httpParams.set('status', params.status);
      }
      if (params.dateFrom) {
        httpParams = httpParams.set('dateFrom', params.dateFrom);
      }
      if (params.dateTo) {
        httpParams = httpParams.set('dateTo', params.dateTo);
      }
      if (params.searchTerm) {
        httpParams = httpParams.set('searchTerm', params.searchTerm);
      }
      if (params.page) {
        httpParams = httpParams.set('page', params.page.toString());
      }
      if (params.pageSize) {
        httpParams = httpParams.set('pageSize', params.pageSize.toString());
      }
    }

    return this.http.get<PaginatedResponse<OrderSummaryDto>>(this.apiUrl, { params: httpParams });
  }

  // Add this method if not already present
  getOrderByCarrierTN(carrierTN: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/by-tn/${carrierTN}`);
  }

  // Add this method if not already present
  getOrderByShopeeNo(shopeeNo: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/by-shopee/${shopeeNo}`);
  }

  // Add this method if not already present
  getOrderParcels(orderUniqueId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${orderUniqueId}/parcels`);
  }

  // Add to your order.service.ts file
 // getAvailableParcels(serviceCode: string): Observable<any> {
 //   const params = new HttpParams().set('serviceCode', serviceCode);
 //   return this.http.get(`${this.apiUrl}/available-parcels`, { params });
 // }

 getAvailableParcels(serviceCode: string, includeCancelled: boolean = false): Observable<any> {
    let params = new HttpParams()
      .set('serviceCode', serviceCode || '');
    
    if (includeCancelled) {
      params = params.set('includeCancelled', 'true');
    }
    
    return this.http.get<any>(`${this.apiUrl}/parcels/available`, { params });
  }

  //getOrderByCartonNo(cartonNo: string): Observable<any> {
  //  return this.http.get(`${this.apiUrl}/by-carton/${cartonNo}`);
  // }

  getOrderByCartonNo(cartonNo: string, includeCancelled: boolean = true): Observable<any> {
  let params = new HttpParams()
    .set('cartonNo', cartonNo);
  
  if (includeCancelled) {
    params = params.set('includeCancelled', 'true');
  }
  
  return this.http.get<any>(`${this.apiUrl}/orders/byCarton`, { params });
}

  // Get detailed information for a specific order
  getOrderDetails(id: string): Observable<OrderDetailDto> {
    return this.http.get<OrderDetailDto>(`${this.apiUrl}/${id}`);
  }

  // Add this new method
  getEligibleCartonsForRepack(request: EligibleCartonsRequest): Observable<PaginatedResponse<EligibleCartonDto>> {
  return this.http.post<PaginatedResponse<EligibleCartonDto>>(`${this.apiUrl}/eligible-cartons`, request);
}

  // Request a carton create repack
  repackCreate(request: RepackCreateRequestDto): Observable<any> { // Backend returns ApiResponse
    return this.http.post<any>(`${this.apiUrl}/repack_create`, request);
  }

  // New method for repack update
  repackUpdate(request: RepackUpdateRequestDto): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/repack_update`, request);
  }

  // New method for repack cancel
  repackCancel(request: RepackCancelRequestDto): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/repack_cancel`, request);
  }

  // Update the status of an order
  updateOrderStatus(id: string, request: StatusUpdateRequestDto): Observable<any> { // Backend returns ApiResponse
    return this.http.put<any>(`${this.apiUrl}/${id}/status`, request);
  }
}